import Constants from '../DataManagement/Constants';
import HelperFunctions from '../DataManagement/HelperFunctions';

const initialState = {
  cardsContent: [
    { key: '', phrase: 'card1', phraseRevealWords: '', image: '', answerIndex: -1 },
    { key: '', phrase: 'card2', phraseRevealWords: '', image: '', answerIndex: -1 },
    { key: '', phrase: 'card3', phraseRevealWords: '', image: '', answerIndex: -1 },
  ],
  cardsUI: [
    {
      x: 0,
      y: 0,
      id: 0,
      order: 0,
      isSelected: false,
    },
    {
      x: 0,
      y: 0,
      id: 1,
      order: 1,
      isSelected: false,
    },
    {
      x: 0,
      y: 0,
      id: 2,
      order: 2,
      isSelected: false,
    },
  ],
};
/**
 * Holds information about the cards on the screen
 * positions data and content
 * @param {*} state
 * @param {*} action
 */
const draggableCardsReducer = (state = initialState, action) => {
  if (action.gameId !== Constants.GAME_ID) {
    return state;
  }
  switch (action.type) {
    case Constants.REDUX_ACTIONS.UPDATE_CARD: {
      const newCards = state.cardsUI.map(card => ({
        ...card,
      }));
      newCards[action.payload.id].x = action.payload.x;
      newCards[action.payload.id].y = action.payload.y;
      newCards[action.payload.id].id = action.payload.id;

      const ordered = HelperFunctions.sortDraggableCardsByXPos(newCards);

      for (let i = 0; i < ordered.length; i++) {
        newCards[ordered[i].id].order = i;
      }

      const cards = [];

      // Build return object
      for (let i = 0; i < state.cardsUI.length; i++) {
        if (i === action.payload.id) {
          cards.push({
            ...state.cardsUI[i],
            id: action.payload.id,
            x: action.payload.x,
            y: action.payload.y,
            order: newCards[i].order,
          });
        } else {
          cards.push({ ...state.cardsUI[i], order: newCards[i].order });
        }
      }

      return {
        ...state,
        cardsUI: cards,
      };
    }
    case Constants.REDUX_ACTIONS.UPDATE_CONTENT: {
      return {
        ...state,
        cardsContent: action.payload,
        cardsUI: state.cardsUI.map((card, i) => ({
          ...card,
          order: i, // Updating content for new item should also reset the order of cards to default [0, 1, 2] order
        })),
      };
    }

    case Constants.REDUX_ACTIONS.UPDATE_SELECTED: {
      const cards = [];

      for (let i = 0; i < state.cardsUI.length; i++) {
        if (action.payload.id === state.cardsUI[i].id) {
          cards.push({ ...state.cardsUI[i], isSelected: action.payload.payload });
        } else {
          cards.push({ ...state.cardsUI[i], isSelected: false });
        }
      }

      return {
        ...state,
        cardsUI: cards,
      };
    }

    case Constants.REDUX_ACTIONS.RESET_CARDS_TO_INITIAL_STATE:
      return initialState;

    default:
      return state;
  }
};

export default draggableCardsReducer;
